import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Grid,
  Box,
  useMediaQuery,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import commitment from "../../images/commitment.jpg";
import initiative from "../../images/initiative.jpg";
import partner from "../../images/partner.jpg";
import target from "../../images/target.jpg";
import volunteer from "../../images/volunteer.jpg";
import Form from "../Form";

const StyledImage = styled("img")({
  width: "100%",
  height: "auto",
  objectFit: "cover",
  borderRadius: "8px",
});

const NavLink = styled("a")({
  textDecoration: "none",
  color: "white",
  fontWeight: "500",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
});

function OurCommitment() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const navItems = [
    { label: "HOME", link: "/", icon: <HomeIcon /> },
    { label: "MEMBERSHIP", link: "/membership" },
    { label: "COMMUNITY", link: "/community" },
    { label: "PARTNER", link: "/partner" },
    { label: "ABOUT US", link: "/about" },
  ];

  const navList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {navItems.map((item) => (
          <ListItem button key={item.label} component="a" href={item.link}>
            {item.icon && <Box sx={{ mr: 1 }}>{item.icon}</Box>}
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "white" }}>
      {/* Commitment Section */}
      <Box sx={{ py: 8, px: { xs: 2, md: 4, lg: 8 } }}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Typography
                  variant="h3"
                  component="h2"
                  sx={{ fontWeight: "bold", color: "black" }}
                >
                  Our Commitment to Society Upliftment by{" "}
                  <Box component="span" sx={{ color: "#1976d2" }}>
                    Technology Readiness at Underprivileged Sections
                  </Box>{" "}
                  of Society for Livelihood
                </Typography>
                <Box sx={{ pt: 2 }}>
                  <Button
                    variant="contained"
                    onClick={() => setOpen(true)}
                    sx={{
                      borderRadius: "50px",
                      px: 4,
                      py: 1.5,
                      fontSize: "1.2rem",
                      fontWeight: 600,
                      bgcolor: "#6c5ce7",
                      "&:hover": { bgcolor: "#5b4cc7" },
                    }}
                  >
                    Join Hands in the Initiative
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ position: "relative" }}>
                <Box sx={{ borderRadius: "8px", overflow: "hidden" }}>
                  <StyledImage
                    src={commitment}
                    alt="Children studying with limited resources"
                  />
                  {/* <Box
                    sx={{
                      position: "absolute",
                      bottom: "1rem",
                      right: "1rem",
                      maxWidth: "250px",
                      bgcolor: "#ffc04d",
                      p: 2,
                      borderRadius: "8px",
                    }}
                  >
                    <Typography
                      sx={{
                        position: "absolute",
                        top: "-2rem",
                        left: "0.5rem",
                        color: "#6c5ce7",
                        fontSize: "3rem",
                        fontWeight: "bold",
                      }}
                    >
                      "
                    </Typography>
                    <Typography sx={{ color: "black", fontWeight: 500 }}>
                      60% of rural youth lack access to digital skilling
                      programs, restricting their ability to enter the AI
                      workforce
                    </Typography>
                  </Box> */}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Statistics Section */}
      <Box sx={{ py: 8, bgcolor: "white" }}>
        <Container>
          <Typography
            variant="h4"
            component="h2"
            sx={{ fontWeight: "bold", textAlign: "center", mb: 8 }}
          >
            Some Figures to Look For
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {/* Job Displacement */}
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={6}>
                <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", color: "#2d2d5f" }}
                  >
                    Job
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", color: "#2d2d5f" }}
                  >
                    Displacement
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Typography
                    sx={{
                      fontSize: "4rem",
                      fontWeight: "bold",
                      color: "#1976d2",
                    }}
                  >
                    26%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    of jobs are susceptible to AI-driven changes, with
                    low-skilled positions being particularly vulnerable.
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {/* Digital Divide */}
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={6}>
                <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", color: "#2d2d5f" }}
                  >
                    Wide
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", color: "#2d2d5f" }}
                  >
                    Digital Divide
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Typography
                    sx={{
                      fontSize: "4rem",
                      fontWeight: "bold",
                      color: "#1976d2",
                    }}
                  >
                    24%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    of rural households in India have internet access, compared
                    to 66% in urban areas
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {/* Income Inequality */}
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={6}>
                <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", color: "#2d2d5f" }}
                  >
                    AI Induced
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", color: "#2d2d5f" }}
                  >
                    Income Inequality
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                  AI advancements tend to disproportionately benefit
                  higher-income earners, potentially widening existing income
                  inequalities. In countries like India, this trend is
                  particularly pronounced.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>

      {/* Our Target Section */}
      <Box sx={{ py: 8, bgcolor: "white" }}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <Box>
                  <Typography
                    variant="h4"
                    component="h2"
                    sx={{ fontWeight: "bold", mb: 4 }}
                  >
                    Our Target
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                  >
                    <Typography
                      sx={{
                        color: "#1976d2",
                        fontSize: "5rem",
                        fontWeight: "bold",
                        lineHeight: 1,
                      }}
                    >
                      1,00,000+
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: "1.1rem", fontWeight: 500 }}
                    >
                      People in Underprivileged areas to be trained for the new
                      technology led skills by 2035
                    </Typography>
                  </Box>
                </Box>

                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <Typography
                        sx={{
                          color: "#1976d2",
                          fontSize: "3.5rem",
                          fontWeight: "bold",
                          lineHeight: 1,
                        }}
                      >
                        500+
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontSize: "1.1rem", fontWeight: 500 }}
                      >
                        Micro Social Entrepreneurs to Drive and take the
                        Initiative ahead
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <Typography
                        sx={{
                          color: "#1976d2",
                          fontSize: "3.5rem",
                          fontWeight: "bold",
                          lineHeight: 1,
                        }}
                      >
                        30+
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontSize: "1.1rem", fontWeight: 500 }}
                      >
                        Community Led Efforts to keep the momentum of the
                        upliftment ongoing
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <StyledImage src={target} alt="Volunteers with raised hands" />
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Our Initiative Section */}
      <Box sx={{ py: 8, bgcolor: "white" }}>
        <Container>
          <Typography
            variant="h4"
            component="h2"
            sx={{ fontWeight: "bold", textAlign: "center", mb: 8 }}
          >
            Our Initiative
          </Typography>

          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <StyledImage src={initiative} alt="Volunteers in blue shirts" />
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: "2.5rem",
                      fontWeight: "bold",
                      color: "#2d2d5f",
                      mb: 2,
                    }}
                  >
                    Educate
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    Educating People on the newer world with more intensive
                    technology to help them onboard for what looks like the
                    future
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: "2.5rem",
                      fontWeight: "bold",
                      color: "#2d2d5f",
                      mb: 2,
                    }}
                  >
                    Facilitate
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    We are collaborating to facilitate infrastructure of
                    Internet, Education to provide access to resources for free
                    to the underprivileged zones.
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: "2.5rem",
                      fontWeight: "bold",
                      color: "#2d2d5f",
                      mb: 2,
                    }}
                  >
                    Include
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                    We are promoting and encouraging MSMEs, Corporates and Major
                    Institutes to start initiatives to support the cause
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Partner and Volunteer Section */}
      <Box sx={{ py: 8, bgcolor: "white" }}>
        <Container>
          <Grid container spacing={6}>
            {/* Partner Us */}
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: "bold", color: "#2d2d5f" }}
                >
                  Partner Us
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                  If you are an Organization, Startup, Corporate, Community
                  group or an Individual who would like to contribute to the
                  initiative with facilitation, Join hands with us in this
                  social cause
                </Typography>
                <Box>
                  <Button
                    variant="contained"
                    onClick={() => setOpen(true)}
                    sx={{
                      borderRadius: "50px",
                      px: 4,
                      py: 1.5,
                      fontWeight: 600,
                      bgcolor: "#6c5ce7",
                      "&:hover": { bgcolor: "#5b4cc7" },
                    }}
                  >
                    Show Interest
                  </Button>
                </Box>
                <Box sx={{ mt: 3 }}>
                  <StyledImage src={partner} alt="Community members" />
                </Box>
              </Box>
            </Grid>

            {/* Volunteer */}
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: "bold", color: "#2d2d5f" }}
                >
                  Volunteer
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                  If you want to volunteer on our programs on part time basis or
                  full time basis to contribute to the social cause, you can
                  volunteer on our various ongoing initiatives
                </Typography>
                <Box>
                  <Button
                    variant="contained"
                    onClick={() => setOpen(true)}
                    sx={{
                      borderRadius: "50px",
                      px: 4,
                      py: 1.5,
                      fontWeight: 600,
                      bgcolor: "#6c5ce7",
                      "&:hover": { bgcolor: "#5b4cc7" },
                    }}
                  >
                    Apply
                  </Button>
                </Box>
                <Box sx={{ mt: 3 }}>
                  <StyledImage src={volunteer} alt="Volunteers with boxes" />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Form
        open={open}
        onClose={() => setOpen(false)}
        category={"Social Partner"}
      />
    </Box>
  );
}

export default OurCommitment;
